import { connect } from 'react-redux'
import { closeWidget } from 'components/AppHeader/actions'
import component from './component'


const mapStateToProps = state => ({
    isArrowVisible: !state.itemsCreationForm.isFocused && state.itemsCreationForm.isEmpty
})

export default connect(
    mapStateToProps,
    { closeWidget }
)(component)
